<template>
  <a-modal
    :visible="visible"
    :title="`设置分类[${categorys[category].name}]并指定事件为:`"
    :footer="null"
    @cancel="
      () => {
        $emit('cancel');
      }
    "
  >
    <a-input placeholder="搜索事件名、描述" v-model="search">
      <a-icon slot="prefix" type="search" />
    </a-input>
    <a-list
      item-layout="horizontal"
      :data-source="events"
      :pagination="pagination"
      :locale="{ emptyText: '无事件' }"
    >
      <a-list-item
        slot="renderItem"
        slot-scope="item"
        @click="$emit('create', { category, event: item.id })"
      >
        <a-list-item-meta :description="item.description">
          <a slot="title">{{ item.name }}[{{ item.abbr }}]</a>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["visible", "category"],
  data() {
    return {
      search: "",
      pagination: {
        pageSize: 5
      }
    };
  },
  computed: {
    events() {
      const result = [];
      const events = this.$store.getters.events;
      for (let key in events) {
        if (
          events[key].active &&
          (events[key].name.match(this.search) ||
            events[key].description.match(this.search))
        ) {
          result.push(events[key]);
        }
      }

      return result;
    },
    ...mapGetters(["categorys"])
  }
};
</script>
